// 3Cat - 3ca, Alleskino - als, AMC on Demand - amo, CG tv - cgv, Chili - chi, Cineverse - cnv, Cranked Up TV - cut
// DocAlliance Films - daf, Kocowa - koc, Kino on Demand - kod, Max - mxx, Mercado Play - mrp, MovieSaints - mvt, Mitele - mte, Nexo Plus - nxp,
// Orange VOD - org, Reveel - rvl, Sooner - snr, Takflix - tak, TF1 - tf1
// Tubi TV - tbv, UAM TV - uat, Videoload - vld, Google Play Movies - ply, Youtube - yot, Yorck on Demand - yrk, wedotv - wa4, Wedo TV - wdt

// prettier-ignore
const excludedPackagesShortNames = [
	'3ca', 'als', 'amo', 'cgv', 'chi', 'cnv', 'cut', 'daf', 'kod', 'koc', 'mrp', 'mte','mvt',
	'mxx', 'nxp', 'org', 'ply', 'rvl', 'snr', 'tak', 'tbv', 'tf1', 'uat', 'vld', 'wa4', 'wdt', 'yot', 'yrk', 
	// DVD/Blu-ray packages
];

export function excludePackages(
	isLoggedIn: boolean,
	entityId: string | undefined,
	country: string,
	isProUser: boolean
) {
	if (isLoggedIn) {
		const excludedPackagesLoggedIn = ['mrp', 'tf1', 'wa4', 'wdt', 'cut'];

		if (!['US', 'IN'].includes(country)) excludedPackagesLoggedIn.push('tbv');
		if (country === 'DE') excludedPackagesLoggedIn.push('snr');

		if (!isProUser && ['TR'].includes(country)) {
			excludedPackagesLoggedIn.push('mxx');
		}

		return excludedPackagesLoggedIn;
	}

	return excludedPackagesShortNames.filter(shortName => !shouldAllowPackageId(shortName, country));
}

// Removes packages from the excludedList based on specific conditions
function shouldAllowPackageId(shortName: string, country: string): boolean {
	if (shortName === 'tbv' && country === 'IN') {
		return true; // Tubi allowed in India
	}
	if (shortName === 'mxx' && !['TR'].includes(country)) {
		return true; // Max allowed outside Australia, Turkey
	}

	if (shortName === 'snr' && country !== 'DE') {
		return true; // Sooner allowed outside Germany
	}
	return false;
}
